var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "page_Container" } },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          {
            staticClass: "temporaryHeight main-container",
            attrs: { id: "main-container" }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageShow,
                    expression: "pageShow"
                  }
                ],
                attrs: { id: "openDistribution" }
              },
              [
                _c("div", { staticClass: "header-img" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "from" },
                  [
                    _c(
                      "van-cell-group",
                      [
                        _c("van-field", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.loginFlag,
                              expression: "!loginFlag"
                            }
                          ],
                          attrs: { placeholder: "请填写手机号" },
                          model: {
                            value: _vm.ruleForm.mobilePhone,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "mobilePhone", $$v)
                            },
                            expression: "ruleForm.mobilePhone"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "van-field",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.loginFlag,
                                expression: "!loginFlag"
                              }
                            ],
                            attrs: {
                              placeholder: "请填写验证码",
                              maxlength: "4"
                            },
                            model: {
                              value: _vm.ruleForm.ivalidateCode,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "ivalidateCode", $$v)
                              },
                              expression: "ruleForm.ivalidateCode"
                            }
                          },
                          [
                            _c(
                              "van-button",
                              {
                                staticClass: "send-btn",
                                class: { sended: !_vm.codeButton },
                                attrs: {
                                  slot: "button",
                                  size: "small",
                                  type: "primary",
                                  id: "btn",
                                  disabled: !_vm.codeButton
                                },
                                on: { click: _vm.handleCode },
                                slot: "button"
                              },
                              [_vm._v(_vm._s(_vm.codeMsg))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("van-field", {
                          attrs: {
                            placeholder: "请填写真实姓名，便于提现打款",
                            maxlength: "20"
                          },
                          model: {
                            value: _vm.ruleForm.accountTrueName,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "accountTrueName", $$v)
                            },
                            expression: "ruleForm.accountTrueName"
                          }
                        }),
                        _vm._v(" "),
                        _c("van-field", {
                          attrs: { placeholder: "请填写真实身份证号" },
                          model: {
                            value: _vm.ruleForm.accountIdCard,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "accountIdCard", $$v)
                            },
                            expression: "ruleForm.accountIdCard"
                          }
                        }),
                        _vm._v(" "),
                        _c("van-field", {
                          attrs: {
                            placeholder: "请填写邀请码(可不填)",
                            maxlength: "6",
                            disabled: _vm.isShareUser
                          },
                          model: {
                            value: _vm.ruleForm.accountInvitationCode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "accountInvitationCode",
                                $$v
                              )
                            },
                            expression: "ruleForm.accountInvitationCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "footer",
                  [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          size: "large",
                          type: "primary",
                          disabled: _vm.btndisabled,
                          round: ""
                        },
                        on: { click: _vm.submitForm }
                      },
                      [_vm._v("提交")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("wxShareLoading")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }